module.exports = __webpack_public_path__ + "assets/img/btn-download-hover-03e859e5.png";